import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListParecer from '../../../components/saude/documentos/parecer';


function ListParecerScreen() {
    return (
        <Fragment>
            <Head titulo="Pareceres Conclusivos do Conselho Municipal de Saúde Sobre a Prestação de Contas Anual" />
            <Header />
            <Container>
               <ListParecer /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListParecerScreen;